<form [formGroup]="wasteForm" class="waste-table">
  <div class="p-d-flex p-flex-nowrap p-nogutter waste-table__header add-row" [ngClass]="{ required: errorWasteNotDefined }">
    <div class="form-group--grow-1">
      <div class="form-group form-group--inline" [ngClass]="{ required: errorWasteOrMaculatureNotDefined }">
        <div class="col-form-label">{{ 'WASTE_ASSIGNMENT.MACULATURE' | translate }}</div>
        <div class="form-control form-control--number">
          <lib-input-number
            [min]="NUM_FIELD_MIN_VALUE"
            (touched)="onMaculatureBlur()"
            [inputStyleClass]="'add-row__maculature'"
            [inputStyle]="INPUT_STYLE"
            [formControlName]="'maculature'"
            [unit]="counterUnitId"
            [showUnit]="false"
          ></lib-input-number>
        </div>
      </div>
    </div>
    <div class="form-group--grow-1">
      <div class="form-group form-group--inline" [ngClass]="{ required: errorWasteOrMaculatureNotDefined }">
        <div class="col-form-label">{{ 'WASTE_ASSIGNMENT.WASTE' | translate }}</div>
        <div class="form-control form-control--number">
          <lib-input-number
            [inputStyle]="INPUT_STYLE"
            [inputStyleClass]="'add-row__waste'"
            [formControlName]="'waste'"
            [min]="NUM_FIELD_MIN_VALUE"
            [unit]="counterUnitId"
            [showUnit]="false"
            (touched)="onWasteBlur()"
          ></lib-input-number>
        </div>
      </div>
    </div>
    <div class="form-group--no-grow">
      <div
        class="form-group form-group--inline form-group--inline--start"
        [ngClass]="isSetupWastePhase === true ? 'setup-waste-unit' : 'waste-unit-span'"
      >
        <span>{{ counterUnitId | formatUnitId }}</span>
      </div>
    </div>
    <div class="form-group--grow-2">
      <div class="form-group form-group--inline">
        <div
          class="form-group--inline form-group--grow-1 form-group--padding"
          [ngClass]="{ required: errorWasteReasonNotDefined }">
          <div class="col-form-label">{{ 'WASTE_ASSIGNMENT.REASON' | translate }}</div>
          <div class="form-control form-control--select">
            <lib-dropdown
              class="add-row__reason"
              [placeholder]="'DROPDOWN_DEFAULT_LABEL' | translate"
              [options]="reasonOptions"
              [formControlName]="'reason'"
              [inlineStyle]="{ width: '180px' }"
              [virtualScroll]="true"
              [panelWidth]="'300px'"
            ></lib-dropdown>
          </div>
        </div>
        <lib-button
          class="add-row__button"
          [loadingTopic]="LOADING_TOPIC"
          [loadingIndicator]="false"
          [disabled]="isAddRowDisabled()"
          (clicked)="addRow()"
          [label]="'WASTE_ASSIGNMENT.OK'"
        ></lib-button>
      </div>
    </div>
  </div>

  <div *ngIf="displayWasteScaleComponent">
    <app-waste-assignment-scale
      (quantityChanged)="onScaleQuantityChange($event)"
    ></app-waste-assignment-scale>
  </div>
  <div
    *ngIf="!isSetupWastePhase && sampleDataEnabled && (aqlQuantity.value > 0 || tgsQuantity.value > 0)"
    class="p-grid p-nogutter waste-table__row waste-table__row--total waste-row--total"
  >
    <div class="p-col-3">
      <div class="form-group form-group--inline">
        <div class="col-form-label no-left-margin">
          {{ 'WASTE_ASSIGNMENT.SAMPLES' | translate }}
        </div>
        <div class="col-form-value">
          <ng-container *ngIf="totalAqlSampleQuantity?.value > 0; else noWasteRecords">
            {{ totalAqlSampleQuantity | formatQuantity : false }}
          </ng-container>
          <ng-template #noWasteRecords>-</ng-template>
        </div>
      </div>
    </div>
    <div class="p-col-1 tgs-qty-padding">
      <div class="form-group form-group--inline">
        <div class="col-form-value">
          {{ 'SAMPLING.AQL' | translate }}
        </div>
      </div>
    </div>
    <div class="p-col-2 aql-padding">
      <div class="form-group form-group--inline">
        <div class="col-form-value">
          <ng-container *ngIf="totalTgsSampleQuantity?.value > 0; else noWasteRecords">
            {{ totalTgsSampleQuantity | formatQuantity : false }}
          </ng-container>
          <ng-template #noWasteRecords>-</ng-template>
        </div>
      </div>
    </div>
    <div class="p-col-1 tgs-padding">
      <div class="form-group form-group--inline">
        <div class="col-form-value">
          {{ 'SAMPLING.TGS' | translate }}
        </div>
      </div>
    </div>
    <div class="p-col-4"></div>
  </div>

  <div class="p-grid p-nogutter waste-table__row waste-table__row--total waste-row--total" (click)="toggleData()">
    <div class="p-col-3">
      <div class="form-group form-group--inline">
        <div class="col-form-label no-left-margin">
          <i class="collapse-control-icon" [ngClass]="isDataShown ? 'icon-arrows-right-filled-close' : 'icon-arrow-right-filled-open'"></i>
          {{ 'WASTE_ASSIGNMENT.TOTAL' | translate }}
        </div>
        <div class="col-form-value" [ngClass]="{ 'total-mal-col-padding': isSetupWastePhase === true }">
          <ng-container *ngIf="wasteAndMaculature?.length > 0; else noWasteRecords">
            {{ getTotalMaculature() | formatQuantity : false }}
          </ng-container>
          <ng-template #noWasteRecords>-</ng-template>
        </div>
      </div>
    </div>
    <div class="p-col-3" [ngClass]="isSetupWastePhase === true ? 'waste-col-padding' : 'run-waste-col-padding'">
      <div class="form-group form-group--inline">
        <div class="col-form-value">
          <ng-container *ngIf="wasteAndMaculature?.length > 0; else noWasteRecords">
            {{ getTotalWaste() | formatQuantity : false }}
          </ng-container>
          <ng-template #noWasteRecords>-</ng-template>
        </div>
      </div>
    </div>
    <div class="p-col-1" [ngClass]="isSetupWastePhase === true ? 'unit-col-padding' : 'run-unit-col-padding'">
      <div class="form-group form-group--inline">
        <div class="col-form-value">
          {{ wasteAssignmentUnitId | formatUnitId }}
        </div>
      </div>
    </div>
    <div class="p-col-5"></div>
  </div>

  <ng-container *ngIf="isDataShown">
    <div *ngIf="wasteAndMaculature?.length > 0; else noDataAvailable">
      <div *ngFor="let item of wasteAndMaculature; trackBy: trackByFunction" class="p-grid p-nogutter waste-table__row waste-row">
        <div class="p-col-1">
          <div class="form-group form-group--inline">
            <div *ngIf="item.isAutoWaste" class="col-form-label">
              <i class="icon-automated icon"></i>
            </div>
          </div>
        </div>
        <div class="p-col-2" [ngClass]="{ 'mal-col-padding': isSetupWastePhase === true }">
          <div class="form-group form-group--inline">
            <div class="col-form-value">{{ item.maculature | formatQuantity : false }}</div>
          </div>
        </div>
        <div class="p-col-3" [ngClass]="isSetupWastePhase === true ? 'waste-col-padding' : 'run-waste-col-padding'">
          <div class="form-group form-group--inline">
            <div class="col-form-value">{{ item.waste | formatQuantity : false }}</div>
          </div>
        </div>
        <div class="p-col-1" [ngClass]="isSetupWastePhase === true ? 'unit-col-padding' : 'run-unit-col-padding'">
          <div class="form-group form-group--inline">
            <div class="col-form-value">{{ counterUnitId | formatUnitId }}</div>
          </div>
        </div>
        <div class="p-col-5" [ngClass]="{ 'waste-reason-margin': isSetupWastePhase === true }">
          <div class="form-group form-group--inline">
            <div class="col-form-label no-left-margin">
              {{ getReasonName(item.wasteReasonId) }}
            </div>
            <div *ngIf="!item.isAutoWaste" class="col-form-label">
              <i class="icon-delete remove-waste-row-button" style="margin: -3px 0" (click)="removeRow(item)"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #noDataAvailable>
      <div class="p-grid p-nogutter waste-table__row waste-row">
        <div class="p-col-12">
          <div class="form-group">
            <div class="col-form-value no-data-found">{{ 'APP.NO_DATA_FOUND' | translate }}</div>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
</form>
